import { Main } from './components/containers';

export const WithdrawalPaymentFiles = () => {
  return <Main />;
};
